<template>
  <div class="login-container">
    <el-card class="login-card">
      <div slot="header" class="login-card-header text-center">
        <img src="@/assets/kaiguang.jpg" alt="系统Logo" class="login-logo">
        <h2>数字靶场管理系统</h2>
      </div>

      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="el-icon-user"
            maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
            maxlength="20"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" style="width: 100%">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="login-copyright">
      © 沈阳胜明科技有限公司 保留所有权利
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          request.post('/api/login', this.loginForm)
            .then(response => {
              if (response.success) {
                this.$message.success('登录成功');
                // 保存用户信息到本地存储
                sessionStorage.setItem('token', response.data);
                // 跳转到首页
                this.$router.push('/home');
              } else {
                this.$message.error(response.message);
              }
            })
            .catch(error => {
              this.$message.error('登录失败：' + error.message);
            });
        }
      });
    }
  }

}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px 0;
}

.login-card {
  width: 400px;
  z-index: 10;
  margin-bottom: 30px;
}

.login-card-header {
  padding: 12px 20px 8px;
}

.login-logo {
  display: block;
  max-width: 180px;
  max-height: 120px;
  margin: 0 auto 8px;
}

.login-card-header h2 {
  margin: 0 0 5px;
  font-size: 20px;
  line-height: 1.4;
  color: #303133;
  font-weight: 600;
}

.login-copyright {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: #909399;
  font-size: 14px;
}
</style>